<template>
  <div class="js-bank-config">
      <!-- 恢复利率设置表单 -->
      <div class="rate-setting" v-if="importable">
          <a-form layout="inline" class="rate-form">

              <!-- 导入选中 -->
              <a-button type="primary" @click="handleImportSelected" >
                  <a-icon type="import" />导入选中
              </a-button>

          </a-form>
      </div>
      <a-tabs default-active-key="fixed" @change="handleTabChange">
          <a-tab-pane key="fixed" tab="固定项配置">
              <div class="table-toolbar">
                  <div class="left">
                      <a-space>
                          <a-button type="primary" @click="handleAddFixedRow">
                              <a-icon type="plus" />添加固定项
                          </a-button>
                          <a-button type="primary" @click="exportFixedToExcel">
                              <a-icon type="download" />导出Excel
                          </a-button>
                          <a-button type="primary" @click="showImportExcelFixedModal = true">
                              <a-icon type="upload" />导入Excel
                          </a-button>

                          <!-- 复制 -->
                          <a-button type="primary" @click="handleCopy">
                              <a-icon type="copy" />复制
                          </a-button>

                          <!-- 粘贴 -->
                          <a-button type="primary" @click="handlePaste">
                              <a-icon type="paste" />粘贴
                          </a-button>

                          <!-- 删除 -->
                          <a-button type="primary" @click="handleDeleteFixed">
                              <a-icon type="delete" />删除
                          </a-button>
                      </a-space>
                  </div>
              </div>
              <div class="custom-table-container">

                  <vxe-grid v-bind="fixedTableOptions" ref="fixedCommonTable" @edit-closed="handleSaveFixedConfig" ></vxe-grid>
              </div>
          </a-tab-pane>
          <a-tab-pane key="random" tab="随机项配置">
              <div class="table-toolbar">
                  <div class="left">
                      <a-space>
                          <a-button type="primary" @click="handleAddRandomRow">
                              <a-icon type="plus" />添加随机项
                          </a-button>
                          <a-button type="primary" @click="exportRandomToExcel">
                              <a-icon type="download" />导出Excel
                          </a-button>
                          <a-button type="primary" @click="showImportExcelRandomModal = true">
                              <a-icon type="upload" />导入Excel
                          </a-button>
                          <!-- 复制 -->
                          <a-button type="primary" @click="handleCopy">
                              <a-icon type="copy" />复制
                          </a-button>

                          <!-- 粘贴 -->
                          <a-button type="primary" @click="handlePaste">
                              <a-icon type="paste" />粘贴
                          </a-button>

                          <!-- 删除 -->
                          <a-button type="primary" @click="handleDeleteRandom">
                              <a-icon type="delete" />删除
                          </a-button>


                      </a-space>
                  </div>
              </div>
              <div class="custom-table-container">

                  <vxe-grid v-bind="randomTableOptions" ref="randomCommonTable" @edit-closed="handleSaveRandomRow"></vxe-grid>

              </div>
          </a-tab-pane>
          <a-tab-pane key="fields" tab="字段列表">
              <div class="custom-table-container">
                  <a-table :columns="fieldColumns" :data-source="fieldItems" :pagination="false" size="small"
                      class="custom-resizable-table compact-table" :components="resizableComponents" />
              </div>
          </a-tab-pane>
      </a-tabs>


      <!-- 导入固定项Excel模态框 -->
      <a-modal title="导入固定项Excel" :visible="showImportExcelFixedModal" @cancel="showImportExcelFixedModal = false"
          @ok="handleImportFixedExcel" :confirmLoading="importLoading">
          <a-upload name="file" :multiple="false" :fileList="fixedExcelFileList"
              :beforeUpload="beforeUploadFixedExcel" accept=".xlsx,.xls" @remove="() => fixedExcelFileList = []">
              <a-button>
                  <a-icon type="upload" /> 选择Excel文件
              </a-button>
              <div style="margin-top: 8px">
                  支持 .xlsx, .xls 格式，请先导出模板，按格式填写后导入。
              </div>
          </a-upload>
      </a-modal>

      <!-- 导入随机项Excel模态框 -->
      <a-modal title="导入随机项Excel" :visible="showImportExcelRandomModal" @cancel="showImportExcelRandomModal = false"
          @ok="handleImportRandomExcel" :confirmLoading="importLoading">
          <a-upload name="file" :multiple="false" :fileList="randomExcelFileList"
              :beforeUpload="beforeUploadRandomExcel" accept=".xlsx,.xls" @remove="() => randomExcelFileList = []">
              <a-button>
                  <a-icon type="upload" /> 选择Excel文件
              </a-button>
              <div style="margin-top: 8px">
                  支持 .xlsx, .xls 格式，请先导出模板，按格式填写后导入。
              </div>
          </a-upload>
      </a-modal>

  </div>
</template>

<script>
import request from '@/utils/request'
import { API } from '@/config/api'
import CommonConfig from './CommonConfig.vue'
import Vue from 'vue'
import * as XLSX from 'xlsx'

export default {
  name: 'BankConfig',
  components: {
      CommonConfig
  },
  props: {
      platform: {
          type: String,
          required: true
      },
      userId: {
          type: [String, Number],
          required: true,
          default: 0
      },
      importable: {
          type: Boolean,
          default: false
      }
  },
  data() {
      return {
          loading: false,
          fixedItems: [],
          randomItems: [],
          // 固定项相关
          currentFixed: {},
          currentFixedIndex: -1,
          fixedColumns: [],
          cacheData: [], // 用于存储固定项编辑前的数据
          // 随机项相关
          currentRandom: {},
          currentRandomIndex: -1,
          randomColumns: [],
          cacheRandomData: [], // 用于存储随机项编辑前的数据
          interestRate: 0, // 利率值
          // 字段列表相关
          fieldColumns: [
              {
                  title: "字段名称",
                  dataIndex: "field_name",
                  width: 300
              },
              {
                  title: "字段标题",
                  dataIndex: "field_title",
                  width: 300
              }
          ],
          fieldItems: [],
          showImportModal: false,
          showImportExcelFixedModal: false,
          showImportExcelRandomModal: false,
          resizableComponents: {
              header: {
                  cell: this.resizableHeaderCell
              }
          },
          importLoading: false,
          fixedExcelFileList: [],
          randomExcelFileList: [],
          rateSaving: false,
          rateStatus: true,
          columnsJson: [],
          type: 'fixed',
          fixedTableOptions: {
              id: 'commonConfigFixedTable',
              rowConfig: {
                  isCurrent: true,
                  isHover: true
              },
              customConfig: {
                  storage: true
              },
              editConfig: {
                  trigger: 'click',
                  mode: 'cell'
              },
              checkboxConfig: {
                  trigger: 'row'
              },
              size: 'mini',
              columns: [],
              data: [],
              border: true,
              showOverflow: true,
              height: 600,
              scrollY: {
                  enabled: true,
                  gt: 0
              },
              resizableConfig: {
                  isDblclickAutoWidth: true
              },
              columnConfig: {
                  resizable: true,
                  drag: true
              },
              menuConfig: {
                  body: {
                      options: [
                          [
                              { code: 'copy', name: '复制' },
                              { code: 'delete', name: '删除' },
                          ]
                      ]
                  }
              }
          },
          randomTableOptions: {
              id: 'commonConfigRandomTable',
              rowConfig: {
                  isCurrent: true,
                  isHover: true
              },
              customConfig: {
                  storage: true
              },
              editConfig: {
                  trigger: 'dblclick',
                  mode: 'row'
              },
              checkboxConfig: {
                  trigger: 'row'
              },
              size: 'mini',
              columns: [],
              data: [],
              border: true,
              showOverflow: true,
              height: 600,
              scrollY: {
                  enabled: true,
                  gt: 0
              },
              resizableConfig: {
                  isDblclickAutoWidth: true
              },
              columnConfig: {
                  resizable: true,
                  drag: true
              },
              menuConfig: {
                  body: {
                      options: [
                          [
                              { code: 'copy', name: '复制' },
                              { code: 'delete', name: '删除' },
                          ]
                      ]
                  }
              }
          }
      }
  },
  watch: {
      platform: {
          handler() {
              // 当平台改变时重新初始化列配置和字段列表
              this.initColumns()
          },
          immediate: false
      },
      fixedItems: {
          handler(val) {
              this.$emit('input', {
                  ...this.value,
                  fixedItems: val
              })
              this.$emit('change')
          },
          deep: true
      },
      randomItems: {
          handler(val) {
              this.$emit('input', {
                  ...this.value,
                  randomItems: val
              })
              this.$emit('change')
          },
          deep: true
      }
  },
  async created() {
      this.initColumns()
      await this.fetchConfigList()
      // 获取利率设置
      await this.getInterestRate()
  },
  methods: {
      initColumns() {

          this.columnsJson = require('@/config/bankConfigColumns.json')
          
          this.fixedColumns = this.columnsJson[this.platform].fixed
          this.randomColumns = this.columnsJson[this.platform].random
          console.log('fixedColumns', this.fixedColumns)
          this.fixedTableOptions.columns = this.fixedColumns.map(column => ({
              field: column.dataIndex,
              title: column.title,
              width: column.width,
              filters: [{ data: '' }],
              filterRender: {
                  name: 'VxeInput'
              },
              editRender: column.editRender || { name: 'input' }
          }))

          // this.fixedTableOptions.columns第一项加上checkbox
          this.fixedTableOptions.columns.unshift({
              field: 'checkbox',
              title: '选择',
              width: 80,
              type: 'checkbox'
          })

          console.log('fixedTableOptions.columns', this.fixedTableOptions.columns)
          this.randomTableOptions.columns = this.randomColumns.map(column => ({
              field: column.dataIndex,
              title: column.title,
              width: column.width,
              filters: [{ data: '' }],
              filterRender: {
                  name: 'VxeInput'
              },
              editRender: column.editRender || { name: 'input' }
          }))

          console.log('randomTableOptions.columns', this.randomTableOptions.columns)

          // this.randomTableOptions.columns第一项加上checkbox
          this.randomTableOptions.columns.unshift({
              field: 'checkbox',
              title: '选择',
              width: 80,
              type: 'checkbox'
          })

          // 生成字段列表数据
          this.generateFieldItems()

      },
      // 生成字段列表数据
      generateFieldItems() {
          // 合并 fixedColumns 和 randomColumns
          const allColumns = [...this.fixedColumns, ...this.randomColumns];

          // 基于 dataIndex 去重，保留第一次出现的字段
          const uniqueColumns = [];
          const seenDataIndexes = new Set();

          allColumns.forEach(column => {
              if (column.dataIndex &&
                  column.dataIndex !== 'action' &&
                  !seenDataIndexes.has(column.dataIndex)) {
                  seenDataIndexes.add(column.dataIndex);
                  uniqueColumns.push(column);
              }
          });

          // 转换为表格数据格式
          this.fieldItems = uniqueColumns.map((column, index) => {
              return {
                  key: index,
                  field_name: column.dataIndex || '',
                  field_title: column.title || ''
              };
          });
      },
      // 获取配置列表
      async fetchConfigList() {
          this.loading = true
          try {
              const res = await request.post(API.BATCH_GENERATE_GET_FIXED_CONFIG_LIST, {
                  user_id: this.userId,
                  platform: this.platform
              })
              if (res.code === 1) {
                  this.fixedTableOptions.data = res.data.fixed_list;
                  this.randomTableOptions.data = res.data.random_list;
              } else {
                  this.$message.error(res.msg || '获取配置失败')
              }
          } catch (error) {
              this.$message.error(error.message || '获取配置失败')
          } finally {
              this.loading = false
          }
      },
      // 保存行数据
      async saveRow(record) {
          try {
              const params = {
                  user_id: this.userId,
                  platform: this.platform
              }

              // 编辑现有记录
              const res = await request.post(API.BATCH_GENERATE_EDIT_FIXED_CONFIG, {
                  id: record.id,
                  ...params
              })
              if (res.code === 1) {
                  await this.fetchConfigList()
              } else {
                  this.$message.error(res.msg || '编辑失败')
                  return
              }

          } catch (error) {
              this.$message.error(error.message || '保存失败')
          }
      },

      async removeFixedItem(record) {
          try {
              const res = await request.post(API.BATCH_GENERATE_DELETE_FIXED_CONFIG, {
                  id: record.id,
                  platform: this.platform
              })
              if (res.code === 1) {
                  this.$message.success('删除成功')
                  this.fetchConfigList()
              } else {
                  this.$message.error(res.msg || '删除失败')
              }
          } catch (error) {
              this.$message.error(error.message || '删除失败')
          }
      },
      async removeRandomItem(record) {
          try {
              const res = await request.post(API.BATCH_GENERATE_DELETE_RANDOM_CONFIG, {
                  id: record.id,
                  platform: this.platform
              })
              if (res.code === 1) {
                  this.$message.success('删除成功')
                  this.fetchConfigList()
              } else {
                  this.$message.error(res.msg || '删除失败')
              }
          } catch (error) {
              this.$message.error(error.message || '删除失败')
          }
      },
      // 保存行数据
      async handleSaveFixedConfig({ row }) {
          try {

              const params = {
                  user_id: this.userId,
                  platform: this.platform,
                  ...row
              }

              // 编辑现有记录
              const res = await request.post(API.BATCH_GENERATE_EDIT_FIXED_CONFIG, {
                  id: row.id,
                  ...params
              })
              if (res.code === 1) {
                //   await this.fetchConfigList()
              } else {
                  this.$message.error(res.msg || '编辑失败')
                  return
              }

          } catch (error) {
              this.$message.error(error.message || '保存失败')
          }
      },
      async handleSaveRandomRow({ row }) {
          try {
              const params = {
                  user_id: this.userId,
                  platform: this.platform,
                  ...row
              }

              // 编辑现有记录
              const res = await request.post(API.BATCH_GENERATE_EDIT_RANDOM_CONFIG, {
                  id: row.id,
                  ...params
              })
              if (res.code === 1) {
                //   this.fetchConfigList()
              } else {
                  this.$message.error(res.msg || '编辑失败')
              }

          } catch (error) {
              this.$message.error(error.message || '保存失败')
          }
      },
      // 添加固定项
      async handleAddFixedRow() {
          // 编辑现有记录
          const res = await request.post(API.BATCH_GENERATE_ADD_FIXED_CONFIG, {
              platform: this.platform,
              user_id: this.userId
          })
          if (res.code === 1) {
              this.fetchConfigList()
              return res.data
          } else {
              this.$message.error(res.msg || '编辑失败')
          }
      },
      // 添加随机项
      async handleAddRandomRow() {
          // 编辑现有记录
          const res = await request.post(API.BATCH_GENERATE_ADD_RANDOM_CONFIG, {
              platform: this.platform,
              user_id: this.userId
          })
          if (res.code === 1) {
              this.fetchConfigList()
          } else {
              this.$message.error(res.msg || '编辑失败')
          }
      },
      // 处理利率变化
      handleRateChange(value) {
          this.interestRate = value
      },
      // 保存利率设置
      async saveInterestRate() {
          try {
              this.rateSaving = true
              const res = await request.post(API.INTEREST_RATE_SAVE, {
                  platform: this.platform,
                  rate: this.interestRate, // 直接使用利率值
                  status: this.rateStatus ? 1 : 0
              })
              if (res.code === 1) {
                  this.$message.success(res.msg || '利率设置保存成功')
                  this.rateSaving = false
              } else {
                  this.$message.error(res.msg || '利率设置保存失败')
                  this.rateSaving = false
              }
          } catch (error) {
              console.error('保存利率设置出错:', error)
              this.$message.error('保存利率设置失败，请稍后重试')
              this.rateSaving = false
          }
      },
      // 获取利率设置
      async getInterestRate() {
          try {
              const res = await request.post(API.INTEREST_RATE_INFO, {
                  platform: this.platform
              })
              if (res.code === 1) {
                  this.interestRate = parseFloat(res.data.rate) // 直接使用利率值
                  this.rateStatus = res.data.status === 1
              } else {
                  this.$message.info(res.msg || '未找到利率设置')
                  this.interestRate = 0
                  this.rateStatus = true
              }
          } catch (error) {
              console.error('获取利率设置出错:', error)
              this.$message.error('获取利率设置失败，请稍后重试')
          }
      },
      // 处理导入成功
      async handleImportSuccess(e) {
          try {
              const { ids, type } = e
              const params = {
                  user_id: this.userId,
                  platform: this.platform,
                  ids: ids,
                  type: type
              }

              const res = await request.post(API.BATCH_GENERATE_IMPORT_CONFIG, params)
              if (res.code === 1) {
                  this.$message.success('导入成功')
                  this.showImportModal = false
                  this.fetchConfigList()
              } else {
                  this.$message.error(res.msg || '导入失败')
              }
          } catch (error) {
              this.$message.error(error.message || '导入失败')
          }
      },
      // 实现可调整列宽的表头单元格组件
      resizableHeaderCell(h, props, children) {
          const { key, ...restProps } = props;
          const col = this.fixedColumns.find(col => col.dataIndex === key) ||
              this.randomColumns.find(col => col.dataIndex === key) ||
              this.fieldColumns.find(col => col.dataIndex === key);

          if (!col || key === 'action') {
              return h('th', { ...restProps }, children);
          }

          let thDom = null;
          const width = col.width || 100;

          const resizeHandle = h('span', {
              class: 'resizable-handle',
              style: {
                  width: '10px',
                  height: '100%',
                  position: 'absolute',
                  right: '0',
                  top: '0',
                  cursor: 'col-resize',
                  userSelect: 'none',
                  borderRight: '1px solid #e8e8e8'
              },
              on: {
                  mousedown: (e) => {
                      this.handleResizeMouseDown(e, key, width);
                  }
              }
          });

          thDom = h('th', {
              ...restProps,
              class: 'resizable-column',
              style: {
                  width: `${width}px`,
                  position: 'relative'
              }
          }, [...children, resizeHandle]);

          return thDom;
      },
      handleResizeMouseDown(e, key, initialWidth) {
          const startX = e.clientX;
          const table = e.target.closest('table');
          const th = e.target.closest('th');
          const initialTableWidth = table.offsetWidth;


          const handleMouseMove = (moveEvent) => {
              const deltaX = moveEvent.clientX - startX;
              const newWidth = Math.max(50, initialWidth + deltaX); // 最小宽度为50px

              // 更新列宽度
              th.style.width = `${newWidth}px`;

              // 更新表格总宽度，保持其他列不变
              table.style.width = `${initialTableWidth + deltaX}px`;

              // 更新列配置中的宽度值 Vue.set



              // 更新列配置中的宽度值
              // const columns = [
              //     ...this.fixedColumns,
              //     ...this.randomColumns,
              //     ...this.fieldColumns
              // ];

              // const targetCol = columns.find(col => col.dataIndex === key);
              // if (targetCol) {
              //     targetCol.width = newWidth;
              // }

              // this.columnsJson[this.platform][this.type] = columns
              // 更新本地


              // 阻止文本选择
              moveEvent.preventDefault();
              moveEvent.stopPropagation();
          };

          const handleMouseUp = (e) => {

              console.log('[newWidth]', e, key, initialWidth)

              const deltaX = e.clientX - startX;
              const newWidth = Math.max(50, initialWidth + deltaX); // 最小宽度为50px

              console.log('[newWidth]', newWidth)

              this.columnsJson[this.platform][this.type].map(item => {
                  if (item.dataIndex === key) {
                      item.width = newWidth
                  }
              });

              localStorage.setItem('bankConfigColumns', JSON.stringify(this.columnsJson))

              document.removeEventListener('mousemove', handleMouseMove);
              document.removeEventListener('mouseup', handleMouseUp);
          };

          document.addEventListener('mousemove', handleMouseMove);
          document.addEventListener('mouseup', handleMouseUp);

          e.preventDefault();
          e.stopPropagation();
      },
      async copyFixedItem(record) {
          try {
              // 调用添加固定项API
              const params = {
                  user_id: this.userId,
                  platform: this.platform
              };

              // 只复制在columns中定义的字段
              this.fixedColumns.forEach(column => {
                  if (column.dataIndex && column.dataIndex !== 'action') {
                      params[column.dataIndex] = record[column.dataIndex];
                  }
              });

              const res = await request.post(API.BATCH_GENERATE_ADD_FIXED_CONFIG, params);
              if (res.code === 1) {
                  this.$message.success('复制成功');
                  // 刷新列表
                  this.fetchConfigList();
              } else {
                  this.$message.error(res.msg || '复制失败');
              }
          } catch (error) {
              this.$message.error(error.message || '复制失败');
          }
      },
      async copyRandomItem(record) {
          try {
              // 调用添加随机项API
              const params = {
                  user_id: this.userId,
                  platform: this.platform
              };

              // 只复制在columns中定义的字段
              this.randomColumns.forEach(column => {
                  if (column.dataIndex && column.dataIndex !== 'action') {
                      params[column.dataIndex] = record[column.dataIndex];
                  }
              });

              const res = await request.post(API.BATCH_GENERATE_ADD_RANDOM_CONFIG, params);
              if (res.code === 1) {
                  this.$message.success('复制成功');
                  // 刷新列表
                  this.fetchConfigList();
              } else {
                  this.$message.error(res.msg || '复制失败');
              }
          } catch (error) {
              this.$message.error(error.message || '复制失败');
          }
      },
      async exportFixedToExcel() {
          try {
              this.$message.loading('正在导出Excel...', 1);

              // 准备要导出的数据
              const exportData = this.$refs.fixedCommonTable.getTableData().fullData.map(item => {
                  const exportItem = {};

                  // 添加id字段用于后续导入时判断是更新还是新增
                  exportItem['ID'] = item.id;

                  // 只导出在columns中定义的字段
                  this.fixedTableOptions.columns.forEach(column => {
                      if (column.field && column.field !== 'action' && column.field !== 'id' && column.field !== 'checkbox') {
                          // 处理不同类型的数据
                          let value = item[column.field];
                          if (column.type === 'boolean' && value !== undefined) {
                              value = value ? '是' : '否';
                          }
                          exportItem[column.title] = value;
                      }
                  });

                  return exportItem;
              });

              // 在前端创建Excel工作表
              const worksheet = XLSX.utils.json_to_sheet(exportData);
              const workbook = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(workbook, worksheet, '固定项配置');

              // 导出文件
              const fileName = `固定项配置_${this.platform}_${new Date().toISOString().slice(0, 10)}.xlsx`;
              XLSX.writeFile(workbook, fileName);

              this.$message.success('导出Excel成功');
          } catch (error) {
              this.$message.error('导出Excel失败: ' + error.message);
          }
      },
      async exportRandomToExcel() {
          try {
              this.$message.loading('正在导出Excel...', 1);

              // 准备要导出的数据
              const exportData = this.$refs.randomCommonTable.getTableData().fullData.map(item => {
                  const exportItem = {};

                  // 添加id字段用于后续导入时判断是更新还是新增
                  exportItem['ID'] = item.id;

                  // 只导出在columns中定义的字段
                  this.randomTableOptions.columns.forEach(column => {
                      if (column.field && column.field !== 'action' && column.field !== 'id' && column.field !== 'checkbox') {
                          // 处理不同类型的数据
                          let value = item[column.field];
                          if (column.type === 'boolean' && value !== undefined) {
                              value = value ? '是' : '否';
                          }
                          exportItem[column.title] = value;
                      }
                  });

                  return exportItem;
              });

              // 在前端创建Excel工作表
              const worksheet = XLSX.utils.json_to_sheet(exportData);
              const workbook = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(workbook, worksheet, '随机项配置');

              // 导出文件
              const fileName = `随机项配置_${this.platform}_${new Date().toISOString().slice(0, 10)}.xlsx`;
              XLSX.writeFile(workbook, fileName);

              this.$message.success('导出Excel成功');
          } catch (error) {
              this.$message.error('导出Excel失败: ' + error.message);
          }
      },
      beforeUploadFixedExcel(file) {
          // 验证文件类型
          const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
              file.type === 'application/vnd.ms-excel';
          if (!isExcel) {
              this.$message.error('只能上传Excel文件!');
              return false;
          }

          // 验证文件大小
          const isLt2M = file.size / 1024 / 1024 < 2;
          if (!isLt2M) {
              this.$message.error('文件大小不能超过2MB!');
              return false;
          }

          // 将文件添加到列表中
          this.fixedExcelFileList = [file];

          // 阻止自动上传
          return false;
      },
      beforeUploadRandomExcel(file) {
          // 验证文件类型
          const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
              file.type === 'application/vnd.ms-excel';
          if (!isExcel) {
              this.$message.error('只能上传Excel文件!');
              return false;
          }

          // 验证文件大小
          const isLt2M = file.size / 1024 / 1024 < 2;
          if (!isLt2M) {
              this.$message.error('文件大小不能超过2MB!');
              return false;
          }

          // 将文件添加到列表中
          this.randomExcelFileList = [file];

          // 阻止自动上传
          return false;
      },
      async handleImportFixedExcel() {
          if (this.fixedExcelFileList.length === 0) {
              this.$message.warning('请先选择Excel文件!');
              return;
          }

          try {
              this.importLoading = true;
              const file = this.fixedExcelFileList[0];

              // 读取Excel文件
              const reader = new FileReader();
              reader.onload = async (e) => {
                  try {
                      const data = new Uint8Array(e.target.result);
                      const workbook = XLSX.read(data, { type: 'array' });

                      // 获取第一个工作表
                      const firstSheetName = workbook.SheetNames[0];
                      const worksheet = workbook.Sheets[firstSheetName];

                      // 将工作表转换为JSON
                      const jsonData = XLSX.utils.sheet_to_json(worksheet);

                      if (jsonData.length === 0) {
                          this.$message.error('Excel文件中没有数据!');
                          this.importLoading = false;
                          return;
                      }

                      // 处理导入的数据
                      const importData = [];
                      const updateData = [];
                      const columnTitleMap = {};

                      // 创建列标题到字段名的映射
                      this.fixedColumns.forEach(col => {
                          if (col.dataIndex && col.dataIndex !== 'action') {
                              columnTitleMap[col.title] = col.dataIndex;
                          }
                      });

                      // 转换Excel数据为系统数据格式
                      jsonData.forEach(row => {
                          const newRecord = {};
                          let recordId = null;

                          // 初始化所有字段为null，确保即使Excel中不存在也会传递给后台
                          this.fixedColumns.forEach(col => {
                              if (col.dataIndex && col.dataIndex !== 'action' && col.dataIndex !== 'checkbox') {
                                  newRecord[col.dataIndex] = null;
                              }
                          });

                          // 获取ID字段值
                          if ('ID' in row) {
                              recordId = row['ID'];
                          }

                          // 遍历Excel中的每一列
                          Object.keys(row).forEach(excelColumn => {
                              if (excelColumn === 'ID') return; // 跳过ID字段，不作为数据字段处理

                              // 查找对应的字段名
                              const fieldName = columnTitleMap[excelColumn];
                              if (fieldName) {
                                  // 根据字段类型处理数据
                                  const column = this.fixedColumns.find(col => col.dataIndex === fieldName);
                                  if (column) {
                                      if (column.type === 'boolean') {
                                          // 处理布尔值
                                          newRecord[fieldName] = row[excelColumn] === '是' || row[excelColumn] === true;
                                      } else {
                                          // 其他类型直接赋值
                                          newRecord[fieldName] = row[excelColumn];
                                      }
                                  } else {
                                      newRecord[fieldName] = row[excelColumn];
                                  }
                              }
                          });

                          // 添加必要的字段
                          newRecord.platform = this.platform;
                          newRecord.user_id = this.userId;

                          // 根据是否有ID判断是更新还是新增
                          if (recordId && !isNaN(recordId)) {
                              newRecord.id = recordId;
                              updateData.push(newRecord);
                          } else {
                              importData.push(newRecord);
                          }
                      });

                      try {
                          let successCount = 0;
                          let addCount = 0;
                          let updateCount = 0;

                          // 处理新增记录 - 逐条添加而不是批量
                          for (const record of importData) {
                              try {
                                  const addRes = await request.post(API.BATCH_GENERATE_ADD_FIXED_CONFIG, {
                                      ...record,
                                      platform: this.platform,
                                      user_id: this.userId
                                  });

                                  if (addRes.code === 1) {
                                      successCount++;
                                      addCount++;
                                  } else {
                                      console.warn('添加失败:', addRes.msg);
                                  }
                              } catch (error) {
                                  console.warn('添加记录失败:', error);
                              }
                          }

                          // 处理更新记录
                          for (const record of updateData) {
                              try {
                                  // 提取需要更新的字段，避免重复设置id, platform, user_id
                                  const updateParams = {};

                                  // 包含所有字段，无论是否为空
                                  this.fixedColumns.forEach(column => {
                                      if (column.dataIndex && column.dataIndex !== 'action' && column.dataIndex !== 'checkbox') {
                                          updateParams[column.dataIndex] = record[column.dataIndex];
                                      }
                                  });

                                  console.log('正在更新记录:', record.id, updateParams);

                                  const updateRes = await request.post(API.BATCH_GENERATE_EDIT_FIXED_CONFIG, {
                                      id: record.id,
                                      platform: this.platform,
                                      user_id: this.userId,
                                      ...updateParams
                                  });

                                  if (updateRes.code === 1) {
                                      successCount++;
                                      updateCount++;
                                      console.log('更新记录成功:', record.id);
                                  } else {
                                      console.warn('更新记录失败:', record.id, updateRes.msg);
                                  }
                              } catch (error) {
                                  console.warn(`更新记录 ID=${record.id} 失败:`, error);
                              }
                          }

                          this.$message.success(`成功处理 ${successCount} 条记录（新增: ${addCount}, 更新: ${updateCount}）`);
                          this.showImportExcelFixedModal = false;
                          this.fixedExcelFileList = [];

                          // 刷新列表
                          this.fetchConfigList();
                      } catch (error) {
                          console.warn('导入处理失败:', error);
                          this.$message.error('导入Excel失败: ' + error.message);
                      }
                  } catch (error) {
                      this.$message.error('解析Excel文件失败: ' + error.message);
                  } finally {
                      this.importLoading = false;
                  }
              };

              reader.onerror = () => {
                  this.$message.error('读取文件失败!');
                  this.importLoading = false;
              };

              reader.readAsArrayBuffer(file);
          } catch (error) {
              this.$message.error('导入Excel失败: ' + error.message);
              this.importLoading = false;
          }
      },
      async handleImportRandomExcel() {
          if (this.randomExcelFileList.length === 0) {
              this.$message.warning('请先选择Excel文件!');
              return;
          }

          try {
              this.importLoading = true;
              const file = this.randomExcelFileList[0];

              // 读取Excel文件
              const reader = new FileReader();
              reader.onload = async (e) => {
                  try {
                      const data = new Uint8Array(e.target.result);
                      const workbook = XLSX.read(data, { type: 'array' });

                      // 获取第一个工作表
                      const firstSheetName = workbook.SheetNames[0];
                      const worksheet = workbook.Sheets[firstSheetName];

                      // 将工作表转换为JSON
                      const jsonData = XLSX.utils.sheet_to_json(worksheet);

                      if (jsonData.length === 0) {
                          this.$message.error('Excel文件中没有数据!');
                          this.importLoading = false;
                          return;
                      }

                      // 处理导入的数据
                      const importData = [];
                      const updateData = [];
                      const columnTitleMap = {};

                      // 创建列标题到字段名的映射
                      this.randomColumns.forEach(col => {
                          if (col.dataIndex && col.dataIndex !== 'action') {
                              columnTitleMap[col.title] = col.dataIndex;
                          }
                      });

                      // 转换Excel数据为系统数据格式
                      jsonData.forEach(row => {
                          const newRecord = {};
                          let recordId = null;

                          // 初始化所有字段为null，确保即使Excel中不存在也会传递给后台
                          this.randomColumns.forEach(col => {
                              if (col.dataIndex && col.dataIndex !== 'action' && col.dataIndex !== 'checkbox') {
                                  newRecord[col.dataIndex] = null;
                              }
                          });

                          // 获取ID字段值
                          if ('ID' in row) {
                              recordId = row['ID'];
                          }

                          // 遍历Excel中的每一列
                          Object.keys(row).forEach(excelColumn => {
                              if (excelColumn === 'ID') return; // 跳过ID字段，不作为数据字段处理

                              // 查找对应的字段名
                              const fieldName = columnTitleMap[excelColumn];
                              if (fieldName) {
                                  // 根据字段类型处理数据
                                  const column = this.randomColumns.find(col => col.dataIndex === fieldName);
                                  if (column) {
                                      if (column.type === 'boolean') {
                                          // 处理布尔值
                                          newRecord[fieldName] = row[excelColumn] === '是' || row[excelColumn] === true;
                                      } else {
                                          // 其他类型直接赋值
                                          newRecord[fieldName] = row[excelColumn];
                                      }
                                  } else {
                                      newRecord[fieldName] = row[excelColumn];
                                  }
                              }
                          });

                          // 添加必要的字段
                          newRecord.platform = this.platform;
                          newRecord.user_id = this.userId;

                          // 根据是否有ID判断是更新还是新增
                          if (recordId && !isNaN(recordId)) {
                              newRecord.id = recordId;
                              updateData.push(newRecord);
                          } else {
                              importData.push(newRecord);
                          }
                      });

                      try {
                          let successCount = 0;
                          let addCount = 0;
                          let updateCount = 0;

                          // 处理新增记录 - 逐条添加而不是批量
                          for (const record of importData) {
                              try {
                                  const addRes = await request.post(API.BATCH_GENERATE_ADD_RANDOM_CONFIG, {
                                      ...record,
                                      platform: this.platform,
                                      user_id: this.userId
                                  });

                                  if (addRes.code === 1) {
                                      successCount++;
                                      addCount++;
                                  } else {
                                      console.warn('添加失败:', addRes.msg);
                                  }
                              } catch (error) {
                                  console.warn('添加记录失败:', error);
                              }
                          }

                          // 处理更新记录
                          for (const record of updateData) {
                              try {
                                  // 提取需要更新的字段，避免重复设置id, platform, user_id
                                  const updateParams = {};

                                  // 包含所有字段，无论是否为空
                                  this.randomColumns.forEach(column => {
                                      if (column.dataIndex && column.dataIndex !== 'action' && column.dataIndex !== 'checkbox') {
                                          updateParams[column.dataIndex] = record[column.dataIndex];
                                      }
                                  });

                                  console.log('正在更新记录:', record.id, updateParams);

                                  const updateRes = await request.post(API.BATCH_GENERATE_EDIT_RANDOM_CONFIG, {
                                      id: record.id,
                                      platform: this.platform,
                                      user_id: this.userId,
                                      ...updateParams
                                  });

                                  if (updateRes.code === 1) {
                                      successCount++;
                                      updateCount++;
                                      console.log('更新记录成功:', record.id);
                                  } else {
                                      console.warn('更新记录失败:', record.id, updateRes.msg);
                                  }
                              } catch (error) {
                                  console.warn(`更新记录 ID=${record.id} 失败:`, error);
                              }
                          }

                          this.$message.success(`成功处理 ${successCount} 条记录（新增: ${addCount}, 更新: ${updateCount}）`);
                          this.showImportExcelRandomModal = false;
                          this.randomExcelFileList = [];

                          // 刷新列表
                          this.fetchConfigList();
                      } catch (error) {
                          console.warn('导入处理失败:', error);
                          this.$message.error('导入Excel失败: ' + error.message);
                      }
                  } catch (error) {
                      this.$message.error('解析Excel文件失败: ' + error.message);
                  } finally {
                      this.importLoading = false;
                  }
              };

              reader.onerror = () => {
                  this.$message.error('读取文件失败!');
                  this.importLoading = false;
              };

              reader.readAsArrayBuffer(file);
          } catch (error) {
              this.$message.error('导入Excel失败: ' + error.message);
              this.importLoading = false;
          }
      },
      handleTabChange(key) {
          this.type = key
      },
      handleFixedEditClosed(e) {
          console.log('行编辑关闭', e)
          // 提交数据
          this.handleSaveFixedConfig(e.row)

      },
      handleRandomEditClosed(row) {
          console.log('行编辑关闭', row)
          // 提交数据
          this.handleSaveRandomRow(row)
      },
      handleCopy() {
          console.log('复制')
          // 获取选中的行 getCheckboxRecords
          if(this.type === 'fixed') {
              this.selectedRows = this.$refs.fixedCommonTable.getCheckboxRecords()
          } else {
              this.selectedRows = this.$refs.randomCommonTable.getCheckboxRecords()
          }
          console.log('selectedRows', this.selectedRows)
      },
      async handlePaste() {
          console.log('粘贴')
          if(this.selectedRows.length === 0) {
              this.$message.warning('请先复制')
              return
          }

          const url = this.type === 'fixed' ? API.BATCH_GENERATE_ADD_FIXED_CONFIG : API.BATCH_GENERATE_ADD_RANDOM_CONFIG

          for(const row of this.selectedRows) {
              // 移除id
              delete row.id
              // 先新增
              const res = await request.post(url, {
                  ...row,
                  platform: this.platform,
                  user_id: this.userId
              })
              console.log('res', res)

          }

          this.fetchConfigList()
      },
      async handleDeleteFixed() {
          // 获取选中的行 getCheckboxRecords
          const selectedRows = this.$refs.fixedCommonTable.getCheckboxRecords()

          if (selectedRows.length === 0) {
              this.$message.warning('请先选择要删除的配置项')
              return
          }

          // 显示确认对话框
          this.$confirm({
              title: '确认删除',
              content: `确定要删除选中的 ${selectedRows.length} 个固定配置项吗？`,
              okText: '确认',
              cancelText: '取消',
              onOk: async () => {
                  try {
                      // 收集所有选中项的ID
                      const ids = selectedRows.map(row => row.id).join(',')

                      // 批量删除
                      const res = await request.post(API.BATCH_GENERATE_DELETE_FIXED_CONFIG, {
                          ids: ids,
                          platform: this.platform,
                      })

                      if (res.code === 1) {
                          this.$message.success(`成功删除 ${selectedRows.length} 个固定配置项`)
                          this.fetchConfigList()
                      } else {
                          this.$message.error(res.msg || '删除失败')
                      }
                  } catch (error) {
                      this.$message.error(error.message || '删除失败')
                  }
              }
          })
      },
      async handleDeleteRandom() {
          // 获取选中的行 getCheckboxRecords
          const selectedRows = this.$refs.randomCommonTable.getCheckboxRecords()

          if (selectedRows.length === 0) {
              this.$message.warning('请先选择要删除的配置项')
              return
          }

          // 显示确认对话框
          this.$confirm({
              title: '确认删除',
              content: `确定要删除选中的 ${selectedRows.length} 个随机配置项吗？`,
              okText: '确认',
              cancelText: '取消',
              onOk: async () => {
                  try {
                      // 收集所有选中项的ID
                      const ids = selectedRows.map(row => row.id).join(',')

                      // 批量删除
                      const res = await request.post(API.BATCH_GENERATE_DELETE_RANDOM_CONFIG, {
                          ids: ids,
                          platform: this.platform,
                      })

                      if (res.code === 1) {
                          this.$message.success(`成功删除 ${selectedRows.length} 个随机配置项`)
                          this.fetchConfigList()
                      } else {
                          this.$message.error(res.msg || '删除失败')
                      }
                  } catch (error) {
                      this.$message.error(error.message || '删除失败')
                  }
              }
          })
      },
      async handleImportSelected() {
          let selectedFixedRows = []
          let selectedRandomRows = []
          try {
              selectedFixedRows = this.$refs.fixedCommonTable.getCheckboxRecords()
          } catch (error) {
          }
          try {
              selectedRandomRows = this.$refs.randomCommonTable.getCheckboxRecords()
          } catch (error) {
          }

          const selectedFixedIds = selectedFixedRows.map(row => row.id) 
          const selectedRandomIds = selectedRandomRows.map(row => row.id)

          this.$emit('import-success', {selectedFixedIds, selectedRandomIds})
          
      }
  }
}
</script>

<style scoped>
.table-toolbar {
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
}

.table-toolbar .left {
  display: flex;
  gap: 8px;
}

.compact-table {
  :deep(.ant-table-tbody > tr > td) {
      padding: 4px 8px;
  }

  :deep(.ant-table-thead > tr > th) {
      padding: 8px 8px;
  }
}

.editable-row-operations a {
  margin-right: 8px;
}

.ant-table-tbody>tr>td {
  cursor: pointer;
}

.ant-table-tbody>tr>td:hover {
  background-color: #f5f5f5;
}

.rate-setting {
  padding: 16px;
  background: #fafafa;
  border-radius: 4px;
  z-index: 1;
}

.rate-form {
  display: flex;
  align-items: center;
}

.rate-form-item {
  margin-right: 8px;
  margin-bottom: 0;
  padding-bottom: 0 !important;
}

.rate-form :deep(.ant-form-item-label) {
  line-height: 32px;
}

.rate-form :deep(.ant-input-number-handler-wrap) {
  opacity: 1;
}

/* 调整主容器样式以适应绝对定位的利率设置 */
.js-bank-config {
  position: relative;
}

.custom-table-container {
  overflow-x: auto;
  width: 100%;
}

.custom-resizable-table {
  table-layout: fixed !important;
}

.resizable-column {
  position: relative;
}

:deep(.resizable-column .resizable-handle) {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 8px;
  cursor: col-resize;
  z-index: 10;
}

:deep(.resizable-column .resizable-handle:hover) {
  background-color: #e8e8e8;
}

:deep(.ant-table-thead > tr > th) {
  position: relative;
  background-clip: padding-box;
  transition: background 0.3s;
}
</style>